fragment EntitySummaryFragment on EntitySummaryInterface {
    id
    entityId
    status
    summary
    userRating
    createdTime
    ... on LeadEntitySummary {
        isValid
        recap
        nextSteps
    }
    ... on EntitySummaryLeadResearch {
        leadFit
        leadFitLabel
        leadFitReasons {
            text
            sentiment
            body
        }
        fields {
            key
            label
            value
        }
        companyOverview {
            headline
            body
        }
    }
}
